export default "__VITE_ASSET__16efd0c2__"